var _ellipse, _ellipse2, _path, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeasureEd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 40,
    viewBox: "0 0 90 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22,
    cy: 20,
    rx: 16,
    ry: 12,
    fill: "#c8c8c8",
    stroke: "#8a8a8a",
    strokeWidth: 1
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 68,
    cy: 20,
    rx: 16,
    ry: 12,
    fill: "#c8c8c8",
    stroke: "#8a8a8a",
    strokeWidth: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 20 H52",
    stroke: "#8a8a8a",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 12,
    x2: 34,
    y2: 28,
    stroke: "#e53935",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 12,
    x2: 80,
    y2: 28,
    stroke: "#e53935",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasureEd);
export default __webpack_public_path__ + "static/media/measure_ed.f503e516191d36c2187796bf915f469a.svg";
export { ForwardRef as ReactComponent };